import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ConfigProvider, Spin } from 'antd';
import configurationStore from 'common/stores/configuration/configuration.store';
import payeaseStore from './stores/payease.store';
import { PAYEASE_THEME } from './payease.constants';
import { PayEaseHeader } from './components/payease-header/payease-header';
import { PassCard } from './components/pass-card/pass-card';
import { CheckoutPanel } from './components/checkout-panel/checkout-panel';
import { OptionPickerModal } from './components/option-picker-modal/option-picker-modal';
import './payease.scss';

export const Payease = observer(() => {
  useEffect(() => {
    payeaseStore.init();
  }, []);

  const communityName = configurationStore.configuration?.default?.communityName;

  return (
    <ConfigProvider theme={PAYEASE_THEME}>
      <div className="payease-page">
        <PayEaseHeader communityName={communityName} />

        <main className="payease-page__main">
          {payeaseStore.loading ? (
            <div className="payease-page__loading">
              <Spin size="large" />
            </div>
          ) : (
            <div className="payease-page__grid">
              <section className="payease-page__passes">
                <div className="payease-page__passes-head">
                  <h2 className="payease-page__section-title">Visitor Passes</h2>
                  <p className="payease-page__hint">Tap a pass to begin</p>
                </div>

                <div className="payease-page__columns">
                  <div>
                    <h3 className="payease-page__column-title">Contractor Passes</h3>
                    <div className="payease-page__column-list">
                      {payeaseStore.contractorPasses.map((pass) => (
                        <PassCard key={pass.id} pass={pass} />
                      ))}
                    </div>
                  </div>
                  <div>
                    <h3 className="payease-page__column-title">Resident &amp; Member Passes</h3>
                    <div className="payease-page__column-list">
                      {payeaseStore.residentAndMemberPasses.map((pass) => (
                        <PassCard key={pass.id} pass={pass} />
                      ))}
                    </div>
                  </div>
                </div>
              </section>

              <aside className="payease-page__checkout">
                <CheckoutPanel />
              </aside>
            </div>
          )}
        </main>

        <OptionPickerModal />
      </div>
    </ConfigProvider>
  );
});

export default Payease;
